import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "loaderGenerateTaskDetailsContainer" }
const _hoisted_2 = { class: "toolNameListTitle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "模块", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, ":", -1)

import { ref, watchEffect } from "vue";
import { SparrowGenTaskReqParam, SparrowToolNameLabelMap } from "@/store/modules/task/types";


import { defineComponent } from "vue";
const __default__ = defineComponent({
    name: "LoaderGenerateTaskDetails",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    payloadStr: {
        type: String,
        required: true,
    }
},
  setup(__props) {

const props = __props;



const sparrowGenTaskReqParam = ref<SparrowGenTaskReqParam>({ toolList: "", machineNameList: "", isDebug: false, whiteListDir: "", });
const toolLabelList = ref<string[]>([]);
const machineNameList = ref<string[]>([]);
const whiteListDir = ref<string>("");
const isDebug = ref<boolean>(false);

function generateConsistentColor(strRaw: string) {
    const stringToHash = function (str: string) {
        let hash = 0;
        if (str.length === 0) return hash;

        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; //
        }
        return hash;
    };

    const colors = [
        '#FF6633', '#FFB399', '#FF33FF', '#114000', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#564704', '#B34D4D',
        '#093269', '#e64e33', '#82129f', '#b91919', '#B34D4D'
    ];

    const hash = Math.abs(stringToHash(strRaw));
    const colorIndex = hash % colors.length;

    return colors[colorIndex];
}


const generateSparrowGenTaskReqParam = (payload: string): SparrowGenTaskReqParam => {
    let res = {
        toolList: "[]",
        machineNameList: "[]",
        isDebug: false,
        whiteListDir: ""
    };
    try {
        res = JSON.parse(payload);
    } catch (err) {
        console.log("failed to get something");
        return res;
    }
    return res;
}

const generateTagList = (payloadStr: string) => {
    sparrowGenTaskReqParam.value = generateSparrowGenTaskReqParam(payloadStr);
    machineNameList.value = sparrowGenTaskReqParam.value.machineNameList.split(",");
    whiteListDir.value = sparrowGenTaskReqParam.value.whiteListDir;
    let toolNameList = [...new Set(sparrowGenTaskReqParam.value.toolList.split(","))];
    toolLabelList.value = toolNameList.reduce((acc: string[], currentValue: string) => {
        let res: string | undefined = SparrowToolNameLabelMap.get(currentValue);
        if (res) {
            acc.push(res);
        }
        return acc;
    }, []);
    isDebug.value = sparrowGenTaskReqParam.value.isDebug;
}

watchEffect(() => {
    if (props && props.payloadStr && props.payloadStr !== "") {
        generateTagList(props.payloadStr)
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_descriptions, {
      direction: "vertical",
      column: 1
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions_item, { label: "机器名：" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(machineNameList.value, (machineName) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: machineName,
                color: generateConsistentColor(machineName),
                type: "info",
                effect: "dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(machineName), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, { label: "白名单文件夹：" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(whiteListDir.value), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_descriptions_item, null, {
          label: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (isDebug.value)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Debug")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_4
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toolLabelList.value, (toolLabel) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: toolLabel,
                color: generateConsistentColor(toolLabel),
                type: "info",
                effect: "dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(toolLabel), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})